const UUID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The value an App Store purchase carries so that Apple's server notifications
 * for it can be matched to this account.
 *
 * Apple reports the value back as the purchase's app account token only when
 * it is a UUID, and the backend matches that token to the account's user id.
 * So this is the user id and nothing else, unchanged, and only when it has
 * that shape. Any other identifier would be accepted by the store and then
 * silently dropped, leaving the purchase unattributable.
 */
export const appStoreAccountToken = (
  user: { user_id?: string | null } | null | undefined,
): string | undefined =>
  typeof user?.user_id === 'string' && UUID_SHAPE.test(user.user_id) ? user.user_id : undefined;
